const NZUltra = () => {
  return (
    <>
      {" "}
      <div className="pt-[86px] pb-[65px] bg-[#f6f6f6]">
        <div className="md:max-w-[80%] max-w-full mx-auto py-[30px]">
          <div className="custom-container px-[30px] text-center">
            <div className=" max-w-[1220px] mx-auto">
              <h2 className="kuunari-bold 2xl:text-[70px] lg:text-[66px] md:text-[55px] text-[40px] lg:mb-[20px] sm:mb-[20px] text-[#383838] leading-[1em] mb-[10px]">
                The Go Anywhere UTV !
              </h2>
              <h3 className="montserrat-semi-bold  text-[22px] text-[#383838] leading-[1em] mb-[16px]">
                Simple Engineering. Straightforward Maintenance.
              </h3>
              <p className="montserrat-medium   text-[#383838] leading-[26px]  text-[16px] mb-[16px]">
                The Tuatara is often compared to the classic Land Rover or Willys Jeep. But what does that mean exactly? It means our machines are known for going anywhere and getting the job done. In fact, in terms of where it will go, we're sure that the Tuatara would be a match for either.
              </p>
              <br />
              {/* <p className="montserrat-medium   text-[#383838] leading-[26px]  text-[16px] mb-[16px]">
                If it's a steep climb to be tackled, there's no need to get a run on. Just apply a low gear, and the
                Tuatara ATV vehicle will use its big fat high-grip tyres and differential lock on each axle, if needed,
                to casually climb to the top.
              </p>
              <br /> */}
              <p className="montserrat-medium   text-[#383838] leading-[26px]  text-[16px] mb-[16px]">
                Like those early workhorses, the Tuatara is built around simple, practical engineering. Its all-steel construction and accessible layout make servicing straightforward. Many maintenance tasks can be handled yourself or by your local mechanic without specialist tools or inflated servicing costs.
              </p>
              <p className="montserrat-medium   text-[#383838] leading-[26px]  text-[16px] mb-[16px]">
                It’s a utility vehicle designed to work, not one that locks you into expensive dealer-only repairs.  </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NZUltra;
